export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MS_ENTRA_CLIENT_ID,
    authority: `${process.env.REACT_APP_MS_ENTRA_LOGIN}${process.env.REACT_APP_MS_ENTRA_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_MS_ENTRA_REDIRECT_URI,
    postLogoutRedirectUri: process.env.REACT_APP_MS_ENTRA_POST_LOGOUT_REDIRECT_URI,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
    secureCookies: false,
    claimsBasedCachingEnabled: false,
  },
};

export const loginRequest = {
  scopes: [
    'offline_access',
    'User.Read',
  ],
};
